import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, mergeProps as _mergeProps, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "gfu-project-description"
}
const _hoisted_2 = {
  key: 0,
  class: "gfu-project-description-section-pledge"
}
const _hoisted_3 = { class: "gfu-project-description-section" }
const _hoisted_4 = { class: "gfu-layout-wrapper gfu-layout-wrapper--extranarrow gfu-4of5--l gfu-3of5--xl" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_table_of_contents = _resolveComponent("table-of-contents")
  const _component_performance_marketing_banner = _resolveComponent("performance-marketing-banner")
  const _component_legal_entity_information = _resolveComponent("legal-entity-information")
  const _component_project_recommendations = _resolveComponent("project-recommendations")
  const _component_mini_wizard_manager = _resolveComponent("mini-wizard-manager")

  return ($options.hasAnyContentSections)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_table_of_contents),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.resolvedSections, (item) => {
          return (_openBlock(), _createElementBlock(_Fragment, {
            key: item.key
          }, [
            (item.children)
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.children, (child) => {
                    return (_openBlock(), _createElementBlock(_Fragment, {
                      key: child.key
                    }, [
                      (child.resolved)
                        ? (_openBlock(), _createBlock(_resolveDynamicComponent(child.resolved.component), _mergeProps({
                            key: 0,
                            ref_for: true
                          }, child.resolved.props), null, 16 /* FULL_PROPS */))
                        : _createCommentVNode("v-if", true)
                    ], 64 /* STABLE_FRAGMENT */))
                  }), 128 /* KEYED_FRAGMENT */))
                ]))
              : (item.resolved)
                ? (_openBlock(), _createBlock(_resolveDynamicComponent(item.resolved.component), _mergeProps({
                    key: 1,
                    ref_for: true
                  }, item.resolved.props), null, 16 /* FULL_PROPS */))
                : _createCommentVNode("v-if", true)
          ], 64 /* STABLE_FRAGMENT */))
        }), 128 /* KEYED_FRAGMENT */)),
        ($props.showAdfoundBanner)
          ? (_openBlock(), _createBlock(_component_performance_marketing_banner, { key: 0 }))
          : _createCommentVNode("v-if", true),
        _createVNode(_component_legal_entity_information, {
          "is-legal-entity-information-visible": $options.showLegalEntityInfo,
          "is-gpsr-visible": $props.isGpsrVisible
        }, null, 8 /* PROPS */, ["is-legal-entity-information-visible", "is-gpsr-visible"]),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_project_recommendations, {
              quantity: 12,
              source: "projectHome",
              "excluded-project-ids": $options.excludedProjectIds
            }, null, 8 /* PROPS */, ["excluded-project-ids"])
          ])
        ]),
        _createVNode(_component_mini_wizard_manager, {
          "product-system-categories": $props.productSystemCategories,
          "is-mini-wizard-enabled": $props.isMiniWizardEnabled
        }, null, 8 /* PROPS */, ["product-system-categories", "is-mini-wizard-enabled"])
      ]))
    : _createCommentVNode("v-if", true)
}